export default function RenderTabs({ components, tabIndex = 0 }) {
  if (components.length === 0) return null;

  const index = Math.min(components.length - 1, Math.max(0, tabIndex));

  return components?.[index] ?? null;
}
